import React, { useState, useEffect, useRef } from "react";
import PopupModal from "../../../common/PopupModal";
import CgFormCreator from "../../../common/CgFormCreator";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAddPracticeLanguages,
  fetchDeletePracticeLanguages,
  fetchPracticeLanguages,
  fetchPracticeLanguageSuggestions,
} from "../../../store/PracticeInfo/PracticeLanguageAction";
import "./practicelanguage.scss";
import { useLocation } from "react-router-dom";

const PracticeLanguages = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmDeleteMap, setConfirmDeleteMap] = useState({});
  const [showError, setShowError] = useState(false);
  const [enableAddButton, setEnableAddButton] = useState(false);

  const location = useLocation();
  const locationData = location.pathname.split("/");
  const practiceId = locationData[2];

  const dispatch = useDispatch();
  const { languageData, langError, lngErrorMsg } = useSelector(
    (state) => state.practiceLanguages
  );

  const {
    languageSuggestionsData,
    languageSuggestionsError,
    languageSuggestionsErrorMsg,
  } = useSelector((state) => state.practiceLanguageSuggestions);

  useEffect(() => {
    dispatch(fetchPracticeLanguages(practiceId));
  }, []);

  useEffect(() => {
    if (languageSuggestionsError || langError) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [languageSuggestionsError, langError]);

  const addedLanguagesRef = useRef([]);

  const toggleConfirmDelete = (displayId, value) => {
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [displayId]: value,
    }));
  };

  const deleteAPiCall = (displayId) => {
    dispatch(
      fetchDeletePracticeLanguages({ practiceId, languageId: displayId })
    ).then(() => {
      console.log("success");
      dispatch(fetchPracticeLanguages(practiceId));
      setConfirmDeleteMap((prev) => ({
        ...prev,
        [displayId]: false,
      }));
    });
  };

  // Render functions
  const RenderLanguagesAutoComplete = () => {
    return (
      <div className="languagesFormWrapper">
        <CgFormCreator
          primaryButton="SAVE"
          secondaryButton="CANCEL"
          noCancel={false}
          enablePrimaryBtn={enableAddButton}
          onSubmitCallback={() => {
            const updatedLanguagesData = addedLanguagesRef.current?.map(
              (item) => item.name
            );
            const data = {
              languages: updatedLanguagesData,
            };
            dispatch(fetchAddPracticeLanguages({ practiceId, data }))
              .then(() => {
                dispatch(fetchPracticeLanguages(practiceId));
              })
              .catch(() => {
                console.log("error");
              });
            setOpenPopup(!openPopup);
          }}
          onCancel={() => {
            setOpenPopup(false);
          }}
          schema={[
            {
              component: "autoComplete",
              suggestions: languageSuggestionsData,
              renderAddedValues: true,
              autoCompletePlaceHolders: "Enter language",
              onValueSelect: (name, values) => {
                addedLanguagesRef.current = values;
                let hasSelectedLanguagesChanged =
                  languageData?.length !== values?.length ||
                  values?.some((_language) => !_language.displayId);

                setEnableAddButton(hasSelectedLanguagesChanged);
              },
              onValueChangeCallback: (res) => {
                dispatch(fetchPracticeLanguageSuggestions(res));
              },
              name: "Languages",
              defaultValue: languageData,
              label: "",
            },
          ]}
        />
      </div>
    );
  };

  const RenderAddLanguagesPopup = () => {
    return (
      <PopupModal
        isOpen={openPopup}
        onClose={() => {
          setOpenPopup(!openPopup);
        }}
        enableSave={false}
        customRender={RenderLanguagesAutoComplete}
        popupHeading="Add languages"
        width="83%"
      />
    );
  };

  const RenderLanguages = () => {
    if (languageData?.length < 1) return null;

    return (
      <div className="languagesWrapper">
        {languageData?.map((item) => {
          return (
            <div className="g-col-6 languages-info" key={item.displayId}>
              {item.name}
              <div>
                {confirmDeleteMap[item.displayId] && (
                  <button
                    type="button"
                    className="btn border-0 canceldelete"
                    onClick={() => toggleConfirmDelete(item.displayId, false)}
                  >
                    CANCEL
                  </button>
                )}
                <button
                  type="button"
                  className={`btn ${
                    confirmDeleteMap[item.displayId]
                      ? "deleteConfirmation"
                      : "delete-button"
                  }`}
                  onClick={() => {
                    if (confirmDeleteMap[item.displayId]) {
                      deleteAPiCall(item.displayId);
                    } else {
                      toggleConfirmDelete(item.displayId, true);
                    }
                  }}
                >
                  {confirmDeleteMap[item.displayId] ? "CONFIRM" : "DELETE"}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const RenderNoLangaugesInfo = () => {
    if (languageData?.length > 0 || langError) return null;

    return (
      <div className="noDataInformationWrapper">
        No language data for this practice
      </div>
    );
  };

  return (
    <div className="languages">
      <h3 className="section-header top-thirty overview">
        Languages{" "}
        <span>
          {languageData?.length > 0 && <span>({languageData?.length}) </span>}
        </span>
        <a
          className="btn edit-button"
          onClick={() => {
            setOpenPopup(!openPopup);
          }}
        >
          +Add
        </a>
      </h3>
      <div className="grid column-gap-2 languagewrapper">
        {showError && (
          <div className="alert alert-danger" role="alert">
            {languageSuggestionsErrorMsg || lngErrorMsg}
          </div>
        )}
      </div>
      {RenderLanguages()}
      {RenderNoLangaugesInfo()}
      {openPopup && RenderAddLanguagesPopup()}
    </div>
  );
};
export default PracticeLanguages;
